module.exports = __webpack_public_path__ + "static/img/news_07.ecab849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_07.jpg
// module id = vl/h
// module chunks = 2